<p>Redirecting to <a href="{{url}}">{{url}}</a></p>